import { HomePage } from 'pages/HomePage/HomePage'
import { Switch, Route } from 'react-router'

import { Layout } from './Layout'
import MasterCampaignPlanPageDynamic from 'pages/MasterCampaignPlanPage/MasterCampaignPlanPageDynamic'
import AIPlanBlueprintPreviewPage from 'pages/AIPlanBlueprintPage/AIPlanBlueprintPreviewPage'
import AIPlanPreviewPage from 'pages/AIPlanPage/AIPlanPreviewPage'

const Routes = () => {
  return (
    <Layout>
      <Switch>
        <Route exact path='/'>
          <HomePage />
        </Route>
        <Route path='/a/:id'>
          <AIPlanBlueprintPreviewPage />
        </Route>
        <Route path='/b/:id'>
          <AIPlanPreviewPage />
        </Route>
        <Route path='/:id'>
          <MasterCampaignPlanPageDynamic />
        </Route>
      </Switch>
    </Layout>
  )
}

export default Routes
